var _path, _path2;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgTickIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 72,
    height: 72,
    viewBox: "0 0 72 72",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M35.9999 71.9998C55.8821 71.9998 71.9998 55.8821 71.9998 35.9999C71.9998 16.1177 55.8821 0 35.9999 0C16.1177 0 0 16.1177 0 35.9999C0 55.8821 16.1177 71.9998 35.9999 71.9998Z",
    fill: "#44C4A1"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M54.9692 16.9365L29.5198 42.386L17.0319 29.8986L10.6914 36.2381L29.5198 55.067L61.3097 23.2761L54.9692 16.9365Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTickIcon);
export default __webpack_public_path__ + "static/media/tick_icon.81ced28471c5f556c4d06ece7b23e61c.svg";
export { ForwardRef as ReactComponent };